import { C } from "../theme/colors";
import { useNavigate } from "react-router-dom";

const fontHeading = "var(--font-heading)";
const fontBody = "var(--font-body)";

// Quick Links with React Router paths
const QUICK_LINKS = [
  { label: "Home", path: "/" },
  { label: "About", path: "/about" },
  { label: "Research", path: "/research" },
  { label: "Training", path: "/training" },
  { label: "Events", path: "/events" },
  { label: "Contact Us", path: "/contact" },
];

const IMPORTANT_LINKS = [
  "Privacy Policy",
  "Disclaimer",
  "Accessibility Statement",
  "Website Policy",
  "Sitemap",
];

const PinIcon = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 24 24"
    fill="none"
    stroke="rgba(255,255,255,0.55)"
    strokeWidth="1.8"
    style={{ flexShrink: 0, marginTop: 2 }}
  >
    <path d="M12 21s-7-6.1-7-11a7 7 0 1 1 14 0c0 4.9-7 11-7 11z" />
    <circle cx="12" cy="10" r="2.5" />
  </svg>
);

const MailIcon = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 24 24"
    fill="none"
    stroke="rgba(255,255,255,0.55)"
    strokeWidth="1.8"
    style={{ flexShrink: 0 }}
  >
    <rect x="3" y="5" width="18" height="14" rx="2" />
    <path d="M3 7l9 6 9-6" />
  </svg>
);

export default function Footer() {
  const navigate = useNavigate();

  return (
    <footer
      style={{
        background: C.navyDark,
        padding: "48px 40px 0",
      }}
    >
      <div
        style={{
          maxWidth: 1260,
          margin: "0 auto",
        }}
      >
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1.6fr 1fr 1fr 1fr",
            gap: 40,
            paddingBottom: 44,
          }}
          className="grid-4"
        >
          {/* BRAND */}
          <div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 12,
                marginBottom: 16,
              }}
            >
              <div>
                <img
                  src="/uploads/crens_logo_final 1.png"
                  alt="CRENS Logo"
                  style={{
                    width: "36px",
                    height: "36px",
                    objectFit: "contain",
                  }}
                />
              </div>

              <div
                style={{
                  fontFamily: fontHeading,
                  fontWeight: 700,
                  fontSize: 16,
                  color: C.white,
                  letterSpacing: 0.3,
                }}
              >
                CRENS @ BITS
              </div>
            </div>

            <p
              style={{
                fontFamily: fontBody,
                fontSize: 13.5,
                color: "rgba(255,255,255,0.55)",
                lineHeight: 1.75,
                maxWidth: 300,
                marginBottom: 20,
              }}
            >
              Centre for Research Excellence in National Security — a Centre
              of Excellence of BITS Pilani.
            </p>

            <div
              style={{
                display: "inline-block",
                border: `1px solid ${C.goldLight}`,
                borderRadius: 6,
                padding: "8px 18px",
              }}
            >
              <span
                style={{
                  fontFamily: fontBody,
                  fontSize: 12.5,
                  fontWeight: 600,
                  color: C.goldLight,
                  letterSpacing: 0.3,
                }}
              >
                Innovate · Achieve · Lead
              </span>
            </div>
          </div>

          {/* QUICK LINKS */}
          <div>
            <div
              style={{
                fontFamily: fontHeading,
                fontWeight: 700,
                fontSize: 11.5,
                color: C.goldLight,
                letterSpacing: 1.5,
                textTransform: "uppercase",
                marginBottom: 18,
              }}
            >
              Quick Links
            </div>

            {QUICK_LINKS.map(({ label, path }) => (
              <button
                key={label}
                onClick={() => navigate(path)}
                style={{
                  display: "block",
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  fontFamily: fontBody,
                  fontSize: 14,
                  fontWeight: 600,
                  color: "rgba(255,255,255,0.85)",
                  marginBottom: 12,
                  padding: 0,
                  textAlign: "left",
                  transition: "color .2s",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.color = C.goldLight;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.color = "rgba(255,255,255,0.85)";
                }}
              >
                {label}
              </button>
            ))}
          </div>

          {/* CONTACT */}
          <div>
            <div
              style={{
                fontFamily: fontHeading,
                fontWeight: 700,
                fontSize: 11.5,
                color: C.goldLight,
                letterSpacing: 1.5,
                textTransform: "uppercase",
                marginBottom: 18,
              }}
            >
              Contact
            </div>

            <div
              style={{
                display: "flex",
                gap: 10,
                marginBottom: 16,
              }}
            >
              <PinIcon />

              <span
                style={{
                  fontFamily: fontBody,
                  fontSize: 13.5,
                  color: "rgba(255,255,255,0.7)",
                  lineHeight: 1.6,
                }}
              >
                BITS Pilani, Hyderabad Campus,
                <br />
                Jawahar Nagar, Shameerpet,
                <br />
                Hyderabad — 500078
              </span>
            </div>

            <div
              style={{
                display: "flex",
                gap: 10,
                alignItems: "center",
              }}
            >
              <MailIcon />

              <span
                style={{
                  fontFamily: fontBody,
                  fontSize: 13.5,
                  color: "rgba(255,255,255,0.7)",
                }}
              >
                crens.head@bits-pilani.ac.in
              </span>
            </div>
          </div>

          {/* IMPORTANT LINKS */}
          <div>
            <div
              style={{
                fontFamily: fontHeading,
                fontWeight: 700,
                fontSize: 11.5,
                color: C.goldLight,
                letterSpacing: 1.5,
                textTransform: "uppercase",
                marginBottom: 18,
              }}
            >
              Important Links
            </div>

            {IMPORTANT_LINKS.map((link) => (
              <button
                key={link}
                style={{
                  display: "block",
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  fontFamily: fontBody,
                  fontSize: 14,
                  fontWeight: 600,
                  color: "rgba(255,255,255,0.85)",
                  marginBottom: 12,
                  padding: 0,
                  textAlign: "left",
                  transition: "color .2s",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.color = C.goldLight;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.color = "rgba(255,255,255,0.85)";
                }}
              >
                {link}
              </button>
            ))}
          </div>
        </div>

        {/* COPYRIGHT */}
        <div
          style={{
            borderTop: "1px solid rgba(255,255,255,0.12)",
            padding: "18px 0",
            display: "flex",
            justifyContent: "space-between",
            flexWrap: "wrap",
            gap: 8,
          }}
        >
          <span
            style={{
              fontFamily: fontBody,
              fontSize: 12.5,
              color: "rgba(255,255,255,0.5)",
            }}
          >
            Centre for Research Excellence in National Security (CRENS) is a
            Centre of Excellence of BITS Pilani | All rights reserved © 2025
          </span>

          <span
            style={{
              fontFamily: fontBody,
              fontSize: 12.5,
              color: "rgba(255,255,255,0.5)",
            }}
          >
            Last Updated: June 2025
          </span>
        </div>
      </div>
    </footer>
  );
}